import { render, staticRenderFns } from "./courseDetails.vue?vue&type=template&id=c413c854&scoped=true"
import script from "./courseDetails.vue?vue&type=script&lang=js"
export * from "./courseDetails.vue?vue&type=script&lang=js"
import style0 from "./courseDetails.vue?vue&type=style&index=0&id=c413c854&prod&lang=scss&scoped=true"
import style1 from "./courseDetails.vue?vue&type=style&index=1&id=c413c854&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c413c854",
  null
  
)

export default component.exports